import { render, staticRenderFns } from "./TimeSeriesItem.vue?vue&type=template&id=da3877e6&scoped=true&"
import script from "./TimeSeriesItem.vue?vue&type=script&lang=js&"
export * from "./TimeSeriesItem.vue?vue&type=script&lang=js&"
import style0 from "./TimeSeriesItem.vue?vue&type=style&index=0&id=da3877e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3877e6",
  null
  
)

export default component.exports